import {deleteSpace, get, post, put} from "../../../api/commonAPI";
import { space} from "../../../api/apiPaths";
import {
    ADD_REVIEW,
    ADD_REVIEW_FAILS,
    ADD_REVIEW_SUCCESS, DELETE_REVIEW, DELETE_REVIEW_FAILS, DELETE_REVIEW_SUCCESS,
    FETCH_REVIEW_DATA,
    FETCH_REVIEW_DATA_FAILS,
    FETCH_REVIEW_DATA_SUCCESS,
    FETCH_SPACE_DATA,
    FETCH_SPACE_DATA_FAILS,
    FETCH_SPACE_DATA_SUCCESS,
    FETCH_USER_DATA,
    FETCH_USER_DATA_FAILS,
    FETCH_USER_DATA_SUCCESS,
    UPDATE_REVIEW, UPDATE_REVIEW_FAILS,
    UPDATE_REVIEW_SUCCESS,
    CLEAR_REVIEW_DETAILS
} from "./SpaceReviewActionTypes";
import {SAVE_WEEKLY_PICKS, SAVE_WEEKLY_PICKS_FAILS} from "../Spaces/SpaceActionTypes";
import toastr from "toastr";
import {getWeeklyPicks} from "../Spaces/SpaceAction";

export const getSpaceData = (page, size, keyword, country, status) => {
    return dispatch => {
        dispatch({
            type: FETCH_SPACE_DATA
        });
        let url = `${space}?page=${page}&size=${size}&dataView=TABLE_VIEW`
        if(keyword) url = `${url}&q=${keyword}`;
        if(status) url = `${url}&status=${status}`;
        if(country) url = `${url}&country=${country}`;
        get(url)
            .then(res => {
                dispatch({
                    type: FETCH_SPACE_DATA_SUCCESS,
                    payload: res.data
                });
            })
            .catch(error => {
                dispatch({
                    type: FETCH_SPACE_DATA_FAILS,
                    payload: error
                });
            });
    };
};

export const getReviewData = (spaceId, eventTypeId) => {
    return dispatch => {
        dispatch({
            type: FETCH_REVIEW_DATA
        });
        let url = `api/space/review?spaceId=${spaceId}&eventId=${eventTypeId}&page=1&size=5000`
        get(url)
            .then(res => {
                dispatch({
                    type: FETCH_REVIEW_DATA_SUCCESS,
                    payload: res.data
                });
            })
            .catch(error => {
                dispatch({
                    type: FETCH_REVIEW_DATA_FAILS,
                    payload: error
                });
            });
    };
};

export const getUsersData = (text) => {
    return dispatch => {
        dispatch({
            type: FETCH_USER_DATA
        });
        let url = `api/user?text=${text}&page=1&size=20`
        get(url)
            .then(res => {
                dispatch({
                    type: FETCH_USER_DATA_SUCCESS,
                    payload: res.data
                });
            })
            .catch(error => {
                dispatch({
                    type: FETCH_USER_DATA_FAILS,
                    payload: error
                });
            });
    };
};

export const addReview = (payload) => {
    return dispatch => {
        dispatch({
            type: ADD_REVIEW
        });
        post(`api/space/review/admin`,payload)
            .then(res => {
                dispatch({
                    type: ADD_REVIEW_SUCCESS,
                    payload:res.data

                })

            })
            .catch(error => {
                dispatch({
                    type: ADD_REVIEW_FAILS,
                    payload:error

                })
            })
    }
};

export const updateReview = (payload, versionHeader) => {
    return dispatch => {
        dispatch({
            type: UPDATE_REVIEW
        });
        put(`api/space/review/admin`,payload, versionHeader)
            .then(res => {
                dispatch({
                    type: UPDATE_REVIEW_SUCCESS,
                    payload:res.data

                })

            })
            .catch(error => {
                dispatch({
                    type: UPDATE_REVIEW_FAILS,
                    payload:error

                })
            })
    }
};

export const deleteReview = (reviewId) => {
    return dispatch => {
        dispatch({
            type: DELETE_REVIEW
        });
        deleteSpace(`api/space/review/${reviewId}`)
            .then(res => {
                dispatch({
                    type: DELETE_REVIEW_SUCCESS,
                    payload:res?.data

                })

            })
            .catch(error => {
                dispatch({
                    type: DELETE_REVIEW_FAILS,
                    payload:error

                })
            })
    }
};

export const clearReviewDetails = () => {
    return {
      type: CLEAR_REVIEW_DETAILS,
    };
  };
